export default "__VITE_ASSET__J_$Mq9pTS5J3cvi72Dvpzw__"